import services from './../../services/service'; // Service Class
import validate from './../../services/validation'; // Validator Class
import Commons from '../../resources/commons.js'; //Commons class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer

let service = new services();
let validator = new validate();

export default {
    name: 'Register',
    mixins: [Commons],
    data () {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_type:"bo",
            terms:false,
            disable_btn: false,
            loading:false,
            action_loading:false,
            data_processing_message:"",
            data_error_message:"",
            error_messages:{},
            know_terms:false,
            card_view:{'card1':true},
            card_back_view:0,
            action_checking:{},
            action_verified:{},
            formComponentKey:0,
            form2ComponentKey:0,
           // data_validated:false,
            set_headers:{},
            ref_code:"",
            group_ref_code:"",
            group_name: '',
            group_is_set: 0,
            redir:'',
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");

            //clear local forage - users data
            localforage.removeItem(service.udb_name).then(function (value) {}).catch(function(err) {});

            //clear all forage //CHECK-LTR
            localforage.clear(); //clear all offline data
        },

        showTerms(action){
            if(action){
                this.know_terms = true;
            }else{
                this.know_terms = false;
            }
        },

        setCardGuide(card){
            //some setts
            this.disable_btn = false; 
            
            if(card == 'card1'){
                this.card_back_view = 'card1';
            }else if(card == 'card2'){
                this.card_back_view = 'card1';
            }else if(card == 'card3'){
                this.card_back_view = 'card2';
            }

            //config
            this.card_view = {};
            this.card_view[card] = true;
        },

        getStatesXX() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCitiesXX(state) {
            service.getCities(this, state).then(function(data) {
                this.cities = data.body;
            })
        },

        validateEmailXX(){
            this.error_messages.email = "";
            if(validator.validateEmail(this.user.email)){
                this.validateData("user","email");
            }else{
                this.error_messages.email = "Email is not validbbb";
            }
            // console.log(this.error_messages.email)
            this.formComponentKey++;
        },

        validatePhoneXX(){
            this.error_messages.phone = "";
            if(validator.validatePhoneNumber(this.user.phone)){
                this.validateData("user","phone");
            }else{
                this.error_messages.phone = "Phone Number is not valid";
                this.user.phone = ""; //redo
            }
            this.formComponentKey++;
        },

        validateUsernameXX(){
            // console.log(validator.vaidateString(this.user.username))
            this.error_messages.username = "";
            if(validator.validateString(this.user.username)){
                this.validateData("user","username");
            }else{
                this.error_messages.username = "Username is not valid"; 
            }
            this.form2ComponentKey++;
        },

        validateDataXX(data_type,data_attr){
            this.disable_btn = true;
            let data_attr_value = '';
            if(data_attr == 'email'){
                data_attr_value = this.user.email;
                this.action_checking.email = true;
            }else if(data_attr == 'phone'){
                data_attr_value = this.user.phone;
            }else if(data_attr == 'username'){
                data_attr_value = this.user.username;
            }
            this.action_checking[data_attr] = true;
            var credentials = {
                data_type: data_type,
                data_attr: data_attr,
                data_attr_value: data_attr_value,
            }
            service.validateDataExist(this, credentials).then(function(data) {
                if(data.body.status == 200) {
                    this.action_checking[data_attr] = false;
                    this.action_verified[data_attr] = true;
                    this.data_validated = true;
                }else{
                    this.action_checking[data_attr] = false;
                    this.error_messages[data_attr] = data.body.message;
                }
                this.formComponentKey++;
                this.disable_btn = false;
            })
            this.formComponentKey++;
        },

        reg_step_01(){
            // this.error_messages = {};
            this.disable_btn = true;
            this.user.agree = true; ///change 
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email
            }

            let navi = this.$router;
            let validated = false
            this.validateEmail(this.user.email);
            this.validatePhone(this.user.phone);
            if(this.data_validated) {
                if(validator.validateString(this.user.name)){
                    if((credentials.user_phone != undefined || credentials.user_email != undefined) || (credentials.user_phone != undefined && credentials.user_email != undefined)) {
                        //validate email
                        if(credentials.user_email != undefined && (!validator.validateEmail(this.user.email))){
                            this.error_messages.email = 'Email is not correct';
                        }else {
                            this.error_messages.email = '';
                            validated = true;
                        }
                        //validate phone number 
                        if(credentials.user_phone != undefined && (!validator.validatePhoneNumber(this.user.phone))){ 
                        this.error_messages.phone = 'Phone is not correct';
                        }else{
                            this.error_messages.phone = '';
                            validated = true;
                        }
                        if(validated){
                            if(this.terms) {
                                this.setCardGuide('card2');
                                this.disable_btn = false;
                                this.data_validated = false;
                            }else {
                                this.error_messages.terms = 'Please agree to Terms';
                                this.disable_btn = false;
                            }
                        }else{
                            this.disable_btn = false;
                        }
                    }else {
                        this.error_messages.email = 'Please enter either email or phone number or both';
                        this.disable_btn = false;
                    }
                }else {
                    this.data_error_message = 'Kindly fill all fields';
                    this.disable_btn = false;
                }
            }
        },

        reg_step_02(){
            this.disable_btn = true;
            // var credentials = {
            //     user_username: this.user.username,
            //     user_password: this.user.password
            // }

            let navi = this.$router;
            if(this.data_validated) {
                // if(credentials.user_username != null && credentials.user_password != null) {
                if((validator.validateString(this.user.username)) && (validator.validateString(this.user.password))) {
                    this.regfinale();
                }else {
                    this.data_error_message = 'Kindly fill all fields';
                    this.disable_btn = false;
                }
            }else{
                this.error_messages.username = "Username is not valid"; 
                this.disable_btn = false;
            }
        },

        regfinale(){

            this.terms_error_message = "";
            this.disable_btn = true;
            // this.user.agree = true; ///change 
            var credentials = {
                user_name: this.user.name,
                user_username:this.user.username || '',
                user_phone: this.user.phone || '',
                user_email: this.user.email || '',
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password,
                user_ref_code: this.ref_code,
                user_group_ref_code: this.group_ref_code,
            }

            let navi = this.$router;
            if((validator.validateString(this.user.username)) && (validator.validateString(this.user.password))) {
                this.loading = true; //activate loading
                service.regUser(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        // toastr.success("Account Created", 'Success!');
                        this.data_processing_message= "Account Created";
                        //log user in
                        if(data.body.data.user_email != ''){
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            }
                        }else if(data.body.data.user_phone != ''){
                            var credentials = {
                                user_detail: data.body.data.user_phone,
                                user_password: data.body.data.user_password
                            }
                        }else{
                            this.data_error_message = "invalid login credentials";
                            this.disable_btn = false;
                            navi.push("login"); 
                        }
                        
                        service.loginUser(this, credentials).then(response => {
                            if(response.body.status == 200) {
                                let data = response.body.data;
                                //use forage instead
                                let self = this;
                                localStorage.setItem("sp_user", data.user_name); 
                                var user_data = {
                                    "user_name": data.user_name,
                                    "user_id": data.user_id,
                                    "sp_token": data.user_session_key,
                                    "sp_token_key": data.user_token_key
                                }
                                localforage.setItem(service.udb_name, user_data).then(function (value) {
                                    //self.doDynamicRedirectsDirects();
                                    if(self.redir != ''){
                                        navi.push(redir);
                                    }else{
                                        self.setCardGuide("card3");
                                    }
                                    //self.setCardGuide("card3");
                                    //navi.push('/create');
                                }).catch(function(err) {});
                            }
                        }).catch((err) => {
                            if(err.status == 404) {
                                // toastr.warning("invalid login credentials", 'Warning!'); 
                                this.data_error_message = "invalid login credentials";
                                this.disable_btn = false;
                            }
                        })

                    }else if(data.body.status == 409) {
                        // toastr.warning("You already have a Sellpoint Account", 'Warning!');
                        this.data_error_message = "You already have a Sellpoint Account, please log in with this email or username";
                        // navi.push("login?u=connect");
                        setTimeout(function(){ navi.push("login?u=connect"); }, 3000); 
                        this.disable_btn = false;
                    }
                }).catch((err) => {
                    if(err) {
                        this.data_error_message = "Something went wrong";
                        this.disable_btn = false;
                    }
                    this.disable_btn = false;
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = 'Kindly fill all fields';
                this.disable_btn = false;
                this.form2ComponentKey++;
            }
        },

        //to handle incoming request flowa
        doDynamicRedirectsDirects(){
            let self = this;
            //check if dynamic_requst is active
            localforage.getItem(service.adr_db_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.$router.push(value.link);
                }else {
                    //else no requests direct to default view
                    self.setCardGuide("card3");
                }
            });
        },

        //
        //to handle incoming request flowa
        doDynamicRedirectsDirects(){
            let self = this;
            //check if dynamic_requst is active
            localforage.getItem(service.adr_db_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.redir = value.link;
                }else {
                    //else no requests direct to default page
                    self.redir = "/";
                }
               // self.reset(); //reset here
            });
        },

    },
    created: function(){
        if((this.$route.params.ref != undefined) && (this.$route.params.ref != '')){
            this.ref_code = this.$route.params.ref;
        }
        //check local storage for refs
        let refcode = localStorage.getItem('refcode');
        let grefcode = localStorage.getItem('grefcode');

        if((refcode != undefined) && (refcode != '')){
            this.ref_code = refcode;
        }

        if((grefcode != undefined) && (grefcode != '')){
            this.group_ref_code = grefcode;
            this.group_is_set = true;
        }

        //check for group
        if((localStorage.getItem('group') != '') || (localStorage.getItem('group') != undefined)){
            this.group_name = localStorage.getItem('group');
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/Register/script.js